import { of } from 'rxjs'
import { catchError, filter, map, switchMap } from 'rxjs/operators'
import { RootEpic } from '~/Store/types'
import { errorNotification } from '~/Services'
import { UsersActions } from './slice'
import { AdminUserService, PageUserResponse } from '~/Services/AdminUsers'


const getAllUsers: RootEpic = action$ =>
  action$.pipe(
    filter(UsersActions.getUsersRequest.match),
    switchMap(action => {
      const { page = 1, pageSize = 10, paging = true } = action.payload || {}
      return AdminUserService.Get.getAllUsers({ page, pageSize, paging })
        .then(res => {
          const data = res.data
          const normalized: PageUserResponse = Array.isArray(data)
            ? {
                results: data,
                queryCount: data.length,
                page: 1,
                pageSize: data.length,
                pageCount: 1,
              }
            : data
          return UsersActions.setUsersSuccess(normalized)
        })
        .catch(error => {
          errorNotification(error)
          return UsersActions.setUsersError()
        })
    }),
  )


const updateUser: RootEpic = (action$) =>
  action$.pipe(
    filter(UsersActions.updateUsersRequest.match),
    switchMap(action =>
      AdminUserService.Post.createUser({
        firstname: action.payload.firstname,
        lastname: action.payload.lastname,
        email: action.payload.email,
        password: (action.payload as any).password,
        forcePasswordChange: false,
      })
        .then(() => UsersActions.updateUsersuccess(action.payload))
        .catch(error =>
          UsersActions.updateUsersError(error.message || 'Update user failed')
        )
    )
  )

export const UsersEpics = [getAllUsers, updateUser]